<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-list-ul_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">取込み生徒リスト</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a class="hyper-text" @click="exitImporting()">戻る</a>
    </div>
    <div class="container">
      <form class="form-inline">
        <v-select
          tag="div"
          v-model="selectedFunction"
          placeholder="クリックして一括機能を選択 / 検索"
          class="form-control"
          id="dropdownMenuButton"
          :clearable="false"
          :options="batchFunctions"
          :reduce="(option) => option.value"
          label="label"
        />

        <button
          type="button"
          class="btn-sm"
          :disabled="!selectedFunction || selected.length == 0"
          @click="selectedFunctionExecute"
        >
          実行
        </button>
        <button type="button" class="btn-sm" @click="exitImporting">
          破棄
        </button>
        <button
          type="button"
          :disabled="!allStudentAlreadyReady"
          class="btn-sm btn-sm-red"
          @click="reviewCurrentImporting"
        >
          本登録
        </button>
      </form>

      <button type="button" class="btn btn-gray" @click="displayColumns">
        表示項目選択
      </button>
      <div class="form-group float-right">
        <label for="text1">検索:</label>
        <input type="text" id="searchform_small" class="form-control" v-model="filter" />
      </div>

      <form class="form-inline showall">
        <div class="form-sort align-items-center">
          <div class="item-count col-2 my-1">
            <label class="mr-sm-2 sr-only" for="inlineFormCustomSelectSmall">
              Preference
            </label>
            <select class="custom-select mr-sm-2" id="inlineFormCustomSelectSmall" v-model="perPage">
              <option :value="totalStudents" selected>全</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="150">150</option>
            </select>
            件表示
          </div>
        </div>
      </form>

      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="table-wrapper-scroll-y">
            <b-table
              ref="student-table"
              :min-width="tableWidth"
              class="sticky-table table-auto-height"
              selectable
              responsive
              sticky-header
              foot-clone
              no-footer-sorting
              :fields="filteredHeaders"
              :filter="filter"
              :filterIncludedFields="searchableFields"
              :per-page="perPage"
              :current-page="currentPage"
              @row-selected="onRowSelected"
              :items="resourcesFiltered"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>

              <template v-slot:head(selected)>
                <b-form-checkbox @input="toggleSelectAll" v-model="selectAll" />
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox @input="selectRow($event, row.index)" v-model="row.rowSelected" />
              </template>

              <template v-slot:cell(error)="row">
                <span class="error-message" v-if="row.value">{{ errorDisplay(row.value) }}</span>
                <span v-else>{{ errorDisplay(row.value) }}</span>
              </template>

              <template v-slot:cell(uid)="row">
                <a class="hyper-text" @click="showEditStudentPopup(row.item.no)">
                  {{ row.value }}
                </a>
              </template>
              <template v-slot:foot()="data">
                <div class="footFilters" v-show="data.field.footFilterable">
                  <v-select
                    tag="div"
                    v-model="footFilters[data.column]"
                    placeholder="フィルタ"
                    class="select-control"
                    :options="tableFootOptions[data.column]"
                    :appendToBody="true"
                  />
                </div>
              </template>
            </b-table>
          </div>
          <div class="pagination-footer">
            <label> {{ totalStudents }} 件中 {{ baseIndex }} から {{ capIndex }} まで表示 </label>
            <div class="float-right">
              <button :disabled="!hasPreviousPage" type="button" class="btn btn-invisible" @click="goToPreviousPage">
                前
              </button>
              <label class="pagination-border text-center">{{ currentPage }}</label>
              <button :disabled="!hasNextPage" type="button" class="btn btn-invisible" @click="goToNextPage">
                次
              </button>
            </div>
          </div>
        </div>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>表示する項目を選択してください</template>

        <template v-slot:body>
          <thead>
            <tr v-for="field in customHeaders" :key="field.key">
              <th scope="row">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :id="field.key" v-model="field.enable" />
                  <label class="custom-control-label" :for="field.key">
                    {{ field.label }}
                  </label>
                </div>
              </th>
            </tr>
          </thead>
        </template>
      </PopUpHolder>
      <PopUpHolder ref="popup_type_edit_student" no-close-on-esc no-close-on-backdrop :customFooter="true">
        <template v-slot:header>
          <div>
            <label class="edit-student-header">入力訂正 生徒ID</label>
            <hr class="divide-line" />
          </div>
        </template>

        <template v-slot:body>
          <table class="table table-form">
            <tbody>
              <ValidationObserver ref="observer" v-slot="{}" @submit.prevent="submit()">
                <IdInputField
                  v-model="selectedStudent.uid"
                  extraRules="required"
                  label="生徒ID"
                  placeholder="半角英数字で入力してください（-、_は可）"
                  inputClass="col-lg-6 student-id-input-field"
                  resourceType="student"
                />
              </ValidationObserver>
            </tbody>
          </table>
        </template>

        <template v-slot:footer>
          <div class="popup-type-edit-student-footer">
            <button type="button" class="btn-green" @click="confirmEditStudentId">保存</button>
          </div>
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { ValidationObserver } from 'vee-validate';
import IdInputField from '@/components/forms/IdInputField.vue';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateTableHeight, resourcesFiltered, tableFootOptions } from '@/helpers/table';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import { basicPresent, basicFieldPresent } from '@/presenters/fields';

export default {
  components: {
    PopUpHolder,
    IdInputField,
    ValidationObserver,
  },
  data() {
    return {
      fields: [
        {
          key: 'selected',
          sortable: false,
          hidable: false,
          enable: true,
          searchable: false,
          class: 'sticky-column left-sticky-column-1',
          thAttr: { width: 20 },
        },
        {
          key: 'no',
          label: '読込No',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'error',
          label: 'エラー',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          footFilterable: true,
        },
        {
          key: 'corporation',
          label: '法人名',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.corporationNameDisplay(value);
          },
        },
        {
          key: 'brand',
          label: 'ブランド名',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.brandNameDisplay(value);
          },
        },
        {
          key: 'school',
          label: '教場名',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.schoolNameDisplay(value);
          },
        },
        {
          key: 'course',
          label: 'コース',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.courseNameDisplay(value);
          },
        },
        {
          key: 'tamaiClass',
          label: 'クラス',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.classNameDisplay(value);
          },
        },
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 300 },
        },
        {
          key: 'figuredTeachingMaterialCodes',
          label: '利用教材',
          sortable: true,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 300 },
          formatter: (value) => {
            return this.getTeachingMaterialNamesByCodes(value);
          },
        },
      ],
      currentPage: 1,
      perPage: 50,
      selectAll: false,
      selected: [],
      selectedStudent: null,
      filter: null,
      selectedFunction: null,
      footFilters: {},
    };
  },
  mounted() {
    if (this.totalStudents === 0) this.$router.push({ name: 'student' });
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/student') {
      this.exitImportingStudents();
    }
    next();
  },
  computed: {
    resources() {
      return this.student_importer.students;
    },
    resourcesFiltered() {
      return resourcesFiltered(this.resources, this.fields, this.footFilters);
    },
    tableFootOptions() {
      return tableFootOptions(this.resources, this.fields);
    },
    baseIndex() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    capIndex() {
      return Math.min(this.baseIndex + this.perPage - 1, this.totalStudents);
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.totalStudents > this.currentPage * this.perPage;
    },
    customHeaders() {
      return this.fields.filter((field) => field.hidable == true);
    },
    filteredHeaders() {
      return this.fields.filter((field) => field.enable == true);
    },
    batchFunctions() {
      return [
        {
          value: 'importStudent',
          label: '生徒の所属を登録',
        },
        {
          value: 'removeStudent',
          label: '取り込みリストから生徒を削除',
        },
      ];
    },
    searchableFields() {
      var fields = this.fields.filter((field) => field.enable == true && field.searchable == true);
      return fields.map((field) => field.key);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    ...mapState(['student_importer']),
    ...mapGetters('student_importer', ['totalStudents', 'allStudentAlreadyReady', 'getStudentByNo']),
    ...mapGetters('role', ['hasAdminPrivilege']),
    ...mapGetters('teaching_material', ['getTeachingMaterialNamesByCodes']),
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateTableHeight();
      updateStickyColumnsAndMinWidth({ leftColumns: 1, rightColumns: 1 });
    },
    confirmEditStudentId() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.$refs['popup_type_edit_student'].hide();
          this.markStudentNoError(this.selectedStudent.no);
          this.selectedStudent = null;
        }
      });
    },
    displayColumns() {
      this.$logger.debug('Display Columns for Students');
      this.$refs['popup_holder'].show();
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
    },
    goToPreviousPage() {
      this.selectAll = false;
      this.currentPage--;
    },
    goToNextPage() {
      this.selectAll = false;
      this.currentPage++;
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.$refs['student-table'].selectAllRows();
      } else {
        this.$refs['student-table'].clearSelected();
      }
    },
    selectRow(checked, index) {
      if (checked) {
        this.$refs['student-table'].selectRow(index);
      } else {
        this.$refs['student-table'].unselectRow(index);
      }
    },
    errorDisplay(field) {
      return basicPresent(field);
    },
    corporationNameDisplay(corporation) {
      return basicFieldPresent(corporation, 'name');
    },
    brandNameDisplay(brand) {
      return basicFieldPresent(brand, 'name');
    },
    schoolNameDisplay(school) {
      return basicFieldPresent(school, 'name');
    },
    courseNameDisplay(course) {
      return basicFieldPresent(course, 'name');
    },
    classNameDisplay(tamaiClass) {
      return basicFieldPresent(tamaiClass, 'name');
    },
    onRowSelected(items) {
      this.selected = items;
    },
    showEditStudentPopup(no) {
      this.selectedStudent = this.getStudentByNo(no);
      this.$logger.debug('Show popup to edit studentId for ' + this.selectedStudent.uid);
      this.$refs['popup_type_edit_student'].show();
    },
    selectedFunctionExecute() {
      this.$logger.debug('Function selected:', this.selectedFunction);
      switch (this.selectedFunction) {
        case 'importStudent':
          this.startEditingInGroup();
          break;
        case 'removeStudent':
          this.removeSelectedStudents();
          break;
        default:
          break;
      }
    },
    startEditingInGroup() {
      this.$logger.debug('Start editing group of ' + this.selected.length + ' Students');
      this.startEditingGroupStudents(this.selected);
      this.$router.push({ name: 'student-import-edit' });
    },
    removeSelectedStudents() {
      let studentNos = this.selected.map((student) => student.no);
      this.$logger.debug('Will remove Students with No: ' + studentNos);
      this.removeStudents(studentNos);
    },
    reviewCurrentImporting() {
      this.$logger.debug('Finish importing Students');
      this.$router.push({ name: 'student-import-confirm' });
    },
    exitImporting() {
      this.$router.push({ name: 'student' });
    },
    ...mapActions('student_importer', [
      'startEditingGroupStudents',
      'removeStudents',
      'exitImportingStudents',
      'markStudentNoError',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.btn-gray {
  margin-bottom: 5px;
}
.btn-sm-red {
  background-color: red;
}
.item-count {
  padding: 0;
  font-size: 10px;
}
.custom-control-label {
  font-weight: normal;
}
.pagination-footer {
  margin-top: 20px;
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
.edit-student-header {
  font-size: 25px;
  color: gray;
  margin-left: 14px;
  margin-bottom: 14px;
}
.error-message {
  color: red;
}

.popup-type-edit-student-footer {
  text-align: right;

  .btn-green {
    margin-right: 10px;
    box-shadow: none;
    border: none;
    background-color: #42b195;
    color: white;
    border-radius: 7px;
    padding: 10px 32px;
    margin-top: 30px;
    margin-bottom: 10px;
  }
}

/deep/ .student-id-input-field {
  min-width: 100%;
  margin-bottom: 7px;
}
</style>
